import { useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { debugLog } from "../lib/logger";
import { SITE_KEY, TURNSTILE_ENABLED, whenTurnstileReady } from "../lib/turnstile";

export { TURNSTILE_ENABLED };

const Turnstile = forwardRef(function Turnstile({ onToken, theme = "dark" }, ref) {
  const containerRef = useRef(null);
  const widgetId = useRef(null);

  useImperativeHandle(ref, () => ({
    reset: () => {
      if (widgetId.current && window.turnstile) {
        try { window.turnstile.reset(widgetId.current); } catch (e) { debugLog("turnstile reset failed", e); }
      }
    },
  }));

  useEffect(() => {
    if (!SITE_KEY) return undefined;
    const render = () => {
      if (!containerRef.current || widgetId.current || !window.turnstile) return;
      widgetId.current = window.turnstile.render(containerRef.current, {
        sitekey: SITE_KEY,
        theme,
        callback: (t) => onToken(t),
        "expired-callback": () => onToken(""),
        "error-callback": () => onToken(""),
      });
    };
    const cancel = whenTurnstileReady(render);
    return () => {
      cancel();
      if (widgetId.current && window.turnstile) {
        try { window.turnstile.remove(widgetId.current); } catch (e) { debugLog("turnstile remove failed", e); }
        widgetId.current = null;
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!SITE_KEY) return null;
  return <div ref={containerRef} className="min-h-[65px]" data-testid="turnstile-widget" />;
});

export default Turnstile;
